export const filterDropdownClasses = {
  active: 'active',
  dropdownIcon: 'dropdown-icon',
  dropdownCrossIcon: 'dropdown-cross-icon',
  disabled: 'disabled',
  selectedValue: 'dropdown-selected-value',
}
